"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MentoriasMensais = function MentoriasMensais() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1044 1087"
  }, _react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h1044v1087H0z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M674.55 715.05c-3.79-9.05-12.9-14.85-21.58-18.41l-58.74-27.05L566 645.8l-45.35 45.1h-.03l19.57 130.82c.07.45-.05.9-.31 1.27l-20.47 28a1.72 1.72 0 01-2.8 0l-20.45-28a1.72 1.72 0 01-.31-1.27l19.56-130.82h-.03l-45.34-45.1-28.22 23.8-58.74 27.05c-8.7 3.56-17.23 8.97-21.58 18.4 0 0-63.85 152.02-29.21 152.02h371.47c34.63 0-29.22-152.01-29.22-152.01zm4.08-208.43a3.28 3.28 0 002.93-3.63l-1.97-16.84-1.37-11.75a3.27 3.27 0 00-3.54-2.87h-2.54l.04-39.43 1.34-.49 4.43-1.6a9.47 9.47 0 000-17.81l-156.7-56.63a9.46 9.46 0 00-6.44 0L358.1 412.2a9.48 9.48 0 000 17.81l57.92 20.94c-4.09 12.9-5.95 27.69-5.78 44.14 1.02 93.87 55.5 149.85 105.93 149.85 49.83 0 104.9-55.98 105.92-149.85.17-15.95-1.59-30.31-5.41-42.94l42.12-15.22.09 34.62h-2.55a3.27 3.27 0 00-3.54 2.88l-3.3 28.59a3.28 3.28 0 002.94 3.61h26.18zM516.18 622.14c-43.99 0-74.34-51.53-80.46-103.04-5.67-47.64 63.23-49.86 67.23-20.33 1.24 9.07-9.19 18.8-8 22.55 5.83 18.5 102.36-60.4 101.7-2.25-.46 41.07-38.55 103.07-80.47 103.07zM209.8 176.3a15.03 15.03 0 100-30.07 15.03 15.03 0 000 30.07zm61.64 0a15.03 15.03 0 100-30.07 15.03 15.03 0 000 30.07zm61.64 0a15.04 15.04 0 100-30.07 15.04 15.04 0 000 30.07z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M858.08 105H177.93A40.97 40.97 0 00137 145.93v343.89a11.16 11.16 0 0022.32 0v-272.3h717.36V289c0 6.16 3.16 0 9.32 0s13 6.16 13 0V145.93A40.97 40.97 0 00858.08 105zm-698.76 90.2v-49.27c0-10.26 8.35-18.6 18.6-18.6h680.16c10.25 0 18.6 8.34 18.6 18.6v49.28H159.32zM887.84 355c-6.17 0-11.16 5.12-11.16 11.43V825.1c0 10.5-8.35 19.05-18.6 19.05H177.92c-10.26 0-18.6-8.55-18.6-19.05V534.06c0-6.31-5-11.43-11.17-11.43-6.16 0-11.16 5.12-11.16 11.43V825.1c0 23.1 18.36 41.91 40.93 41.91h680.14c22.57 0 40.93-18.8 40.93-41.91V366.43c0-6.31-5-11.43-11.16-11.43z"
  }), _react.default.createElement("path", {
    fill: "#63DC3E",
    fillRule: "evenodd",
    d: "M727.71 44.83c68.43-2.88 137.83-1.9 206.27 2.9a43.9 43.9 0 0140.6 39 868.912 868.912 0 010 188.56 43.43 43.43 0 01-3.32 12.54 43.72 43.72 0 01-37.3 26.47 1849.4 1849.4 0 01-138.48 4.5h-.04a8.38 8.38 0 00-6.92 3.55c-15.76 22.68-41.16 44.27-59.7 58.4a25.48 25.48 0 01-26.85 2.57 25.44 25.44 0 01-14.23-22.94v-37.4c0-4.4-3.46-8.1-7.87-8.4l-3.76-.26-.26-.02a43.93 43.93 0 01-40.6-39.08 867.74 867.74 0 010-188.48 43.9 43.9 0 0140.61-39c17.18-1.22 34.63-2.2 51.85-2.91z",
    clipRule: "evenodd"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M967.2 14.51a1848.47 1848.47 0 00-258.12 0 43.9 43.9 0 00-40.61 39.01 867.74 867.74 0 00-.01 188.48 43.93 43.93 0 0040.6 39.09l4.03.27c4.41.3 7.87 4 7.87 8.4v37.4c0 9.8 5.45 18.6 14.22 22.94a25.49 25.49 0 0026.85-2.57c18.54-14.13 43.95-35.72 59.7-58.4a8.38 8.38 0 016.92-3.55h.05c46.14.24 92.73-1.28 138.47-4.5a43.72 43.72 0 0037.31-26.47 43.64 43.64 0 003.31-12.53c6.85-62.56 6.85-126 0-188.56a43.9 43.9 0 00-40.6-39zm19.95 225.3a22.73 22.73 0 01-1.74 6.6 23.06 23.06 0 01-19.69 13.97c-45.23 3.18-91.3 4.67-136.9 4.44h-.17a29.13 29.13 0 00-23.96 12.47c-14.22 20.45-37.89 40.5-55.24 53.72a4.7 4.7 0 01-5.05.49 4.7 4.7 0 01-2.68-4.33v-37.4a29.28 29.28 0 00-27.25-29.12l-3.95-.27a23.18 23.18 0 01-21.42-20.64 847.17 847.17 0 010-183.96 23.15 23.15 0 0121.43-20.56 1827.96 1827.96 0 01255.21 0 23.14 23.14 0 0121.4 20.56 846.98 846.98 0 01.01 184.03z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M945.08 66.32h-213.9a10.38 10.38 0 000 20.77h213.9a10.38 10.38 0 000-20.77zm0 43.93h-213.9a10.38 10.38 0 000 20.76h213.9a10.38 10.38 0 000-20.76zm-93.58 43.93H731.17a10.38 10.38 0 000 20.76H851.5a10.38 10.38 0 000-20.76z"
  }), _react.default.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M189.5 867h657l159.5 211H31l158.5-211z"
  }), _react.default.createElement("defs", null, _react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "518.5",
    x2: "518.5",
    y1: "824.77",
    y2: "1078",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#F2F2F2"
  }), _react.default.createElement("stop", {
    offset: "0.58",
    stopColor: "#fff",
    stopOpacity: "0"
  }))));
};

var _default = MentoriasMensais;
exports.default = _default;